import React, { useMemo } from 'react';
import { Modal } from 'tea-component';
import { useIntl } from 'umi';
import { ModalInfoType } from '../index';
import EditMenu from './EditMenu';
import EditFolder from './EditFolder';
import EditDashboard from './EditDashboard';
import EditSubFolder from './EditSubFolder';
import AccessDenied from './AccessDenied';

export interface ModalPrposType {
  modalInfo: ModalInfoType;
  close: () => void;
  exit: () => void;
}

export default (props: ModalPrposType) => {
  const { modalInfo: { editType, show, type }, close, exit } = props;
  const { formatMessage } = useIntl();
  const caption = useMemo(()=> {
    if(!type) return '';
    if(type === 'add' && editType){
      return formatMessage({ id: `menu_new_${editType}` });
    }
    return formatMessage({ id: 'menu_rename' });
  },[editType, formatMessage, type]);

  const renderComponent = () => {
    switch (editType) {
      case 'dashboard':
        return <EditDashboard {...props} />;
      case 'subfolder':
        return <EditSubFolder {...props} />;
      case 'folder':
        return <EditFolder {...props} />;
      case 'menu':
        return <EditMenu {...props} />;
      case 'access_denied':
        return <AccessDenied {...props} />;
      default:
        return null;
    }
  };
  
  return (
    <Modal
      disableEscape
      size={editType === 'access_denied' ? 500 : 680}
      visible={show}
      caption={caption}
      onClose={close}
      onExited={exit}
      // maskStyle={{background: '#fff'}}
    >
      {renderComponent()}
    </Modal>
  );
};